import { render, staticRenderFns } from "./MajorScheme.vue?vue&type=template&id=1afb7196&scoped=true&"
import script from "./MajorScheme.vue?vue&type=script&lang=js&"
export * from "./MajorScheme.vue?vue&type=script&lang=js&"
import style0 from "./MajorScheme.vue?vue&type=style&index=0&id=1afb7196&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afb7196",
  null
  
)

export default component.exports